(() => {
  'use strict';
  const context = window.SIMOTEK_PAGE_CONTEXT || {};
  const debug = context.qaConsole === true;
  const clean = (value) => {
    if (value == null) return value;
    if (Array.isArray(value)) return value.slice(0, 20).map(clean);
    if (typeof value === 'object') {
      const out = {};
      Object.keys(value).slice(0, 30).forEach((key) => {
        if (/phone|email|address|name|customer/i.test(key)) return;
        out[key] = clean(value[key]);
      });
      return out;
    }
    return typeof value === 'string' ? value.slice(0, 240) : value;
  };

  const track = (name, payload = {}) => {
    const safeName = String(name || '').trim().replace(/[^a-z0-9_:-]/gi, '_').slice(0, 64);
    if (!safeName) return;
    const detail = clean({
      ...payload,
      page_type: context.pageType || '',
      currency: context.currency || 'MAD',
      theme_version: context.themeVersion || '3.7.0'
    });

    document.dispatchEvent(new CustomEvent(`simotek:${safeName}`, { detail }));

    // If GTM/dataLayer is already installed, expose SIMOTEK events without installing
    // another tracker or duplicating Shopify's standard Customer Events.
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `simotek_${safeName}`, simotek: detail });
    }

    // Shopify permits merchants to publish custom (not standard) Customer Events.
    // Keep the unique SIMOTEK prefix to avoid collisions with Shopify standard events.
    try {
      const published = window.Shopify?.analytics?.publish?.(`simotek:${safeName}`, detail);
      published?.catch?.(() => {});
    } catch (_) {}

    if (debug && window.console) console.info(`[SIMOTEK QA] ${safeName}`, detail);
  };

  window.SimotekAnalytics = Object.freeze({ track, context });

  // Non-PII diagnostics: useful in Theme Preview, silent by default.
  window.addEventListener('error', (event) => {
    if (!debug) return;
    console.error('[SIMOTEK QA] JS error', event.message, event.filename, event.lineno);
  });
  window.addEventListener('unhandledrejection', (event) => {
    if (!debug) return;
    console.error('[SIMOTEK QA] Unhandled promise rejection', event.reason);
  });

  if (context.pageType === 'product' && context.product) {
    track('product_view', { product: context.product });
  } else if (context.pageType === 'collection' && context.collection) {
    track('collection_view', { collection: context.collection });
  }
})();
